import React from 'react';
import '../css/Home.css';

const Home01 = () => {
    const tagline = 'BE A THERESIAN!';
    const subTagline = 'A Different Kind of Smart, A Different Kind of Learning!';

    return (
        <div className='home01-container'>
            <div className='flex-center home01-text-container'>
                <div className='home01-tagline palanquin-dark bold primary-yellow-text'>{tagline}</div>
                <div className='home01-subtagline'>{subTagline}</div>
            </div>
            <div className='flex-center home01-learn-more-container'>
                <div className='home-learn-more home01-learn-more secondary-white-text flex-center'>
                    Learn More
                </div>
            </div>
            
        </div>
    );
};

export default Home01;
